(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ h; },
/* harmony export */   "F": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
const c=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({setTheme:e=>{},themes:[]}),l=()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(c),d=["light","dark"],u="(prefers-color-scheme: dark)",h=({forcedTheme:t,disableTransitionOnChange:a=!1,enableSystem:m=!0,enableColorScheme:i=!0,storageKey:l="theme",themes:h=["light","dark"],defaultTheme:$=(m?"system":"light"),attribute:p="data-theme",value:T,children:w})=>{const[S,b]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>f(l,$)),[E,k]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>f(l)),x=T?Object.values(T):h,L=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{const n=g(e);k(n),"system"!==S||t||C(n,!1)},[S,t]),I=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(L);I.current=L;const C=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e,t=!0,n=!0)=>{let r=(null==T?void 0:T[e])||e;const o=a&&n?v():null;if(t)try{localStorage.setItem(l,e)}catch(e){}if("system"===e&&m){const e=g();r=(null==T?void 0:T[e])||e}if(n){const e=document.documentElement;"class"===p?(e.classList.remove(...x),e.classList.add(r)):e.setAttribute(p,r),null==o||o()}},[]);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const e=function(){return I.current(...[].slice.call(arguments))},t=window.matchMedia(u);return t.addListener(e),e(t),()=>t.removeListener(e)},[]);const M=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{t?C(e,!0,!1):C(e),b(e)},[t]);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const e=e=>{e.key===l&&M(e.newValue||$)};return window.addEventListener("storage",e),()=>window.removeEventListener("storage",e)},[M]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!i)return;let e=t&&d.includes(t)?t:S&&d.includes(S)?S:"system"===S&&E||null;document.documentElement.style.setProperty("color-scheme",e)},[i,S,E,t]),react__WEBPACK_IMPORTED_MODULE_0__.createElement(c.Provider,{value:{theme:S,setTheme:M,forcedTheme:t,resolvedTheme:"system"===S?E:S,themes:m?[...h,"system"]:h,systemTheme:m?E:void 0}},react__WEBPACK_IMPORTED_MODULE_0__.createElement(y,{forcedTheme:t,storageKey:l,attribute:p,value:T,enableSystem:m,defaultTheme:$,attrs:x}),w)},y=(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(({forcedTheme:t,storageKey:n,attribute:r,enableSystem:o,defaultTheme:s,value:a,attrs:m})=>{const c="class"===r?`var d=document.documentElement.classList;d.remove(${m.map(e=>`'${e}'`).join(",")});`:"var d=document.documentElement;",l=(e,t)=>{e=(null==a?void 0:a[e])||e;const n=t?e:`'${e}'`;return"class"===r?`d.add(${n})`:`d.setAttribute('${r}', ${n})`},d="system"===s;return react__WEBPACK_IMPORTED_MODULE_0__.createElement(next_head__WEBPACK_IMPORTED_MODULE_1__["default"],null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("script",t?{key:"next-themes-script",dangerouslySetInnerHTML:{__html:`!function(){${c}${l(t)}}()`}}:o?{key:"next-themes-script",dangerouslySetInnerHTML:{__html:`!function(){try {${c}var e=localStorage.getItem('${n}');${d?"":l(s)+";"}if("system"===e||(!e&&${d})){var t="${u}",m=window.matchMedia(t);m.media!==t||m.matches?${l("dark")}:${l("light")}}else if(e) ${a?`var x=${JSON.stringify(a)};`:""}${l(a?"x[e]":"e",!0)}}catch(e){}}()`}}:{key:"next-themes-script",dangerouslySetInnerHTML:{__html:`!function(){try{${c}var e=localStorage.getItem("${n}");if(e){${a?`var x=${JSON.stringify(a)};`:""}${l(a?"x[e]":"e",!0)}}else{${l(s)};}}catch(t){}}();`}}))},(e,t)=>e.forcedTheme===t.forcedTheme),f=(e,t)=>{if("undefined"==typeof window)return;let n;try{n=localStorage.getItem(e)||void 0}catch(e){}return n||t},v=()=>{const e=document.createElement("style");return e.appendChild(document.createTextNode("*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")),document.head.appendChild(e),()=>{window.getComputedStyle(document.body),setTimeout(()=>{document.head.removeChild(e)},1)}},g=e=>(e||(e=window.matchMedia(u)),e.matches?"dark":"light");


/***/ }),

/***/ 6363:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(3847);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6774);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_globals_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _fortawesome_fontawesome_free_css_all_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2937);
/* harmony import */ var _fortawesome_fontawesome_free_css_all_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_fontawesome_free_css_all_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(425);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_themes__WEBPACK_IMPORTED_MODULE_3__/* .ThemeProvider */ .f, {
        attribute: "class",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({}, pageProps))
    });
}
/* harmony default export */ __webpack_exports__["default"] = (MyApp);


/***/ }),

/***/ 2937:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6774:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6363), __webpack_exec__(880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);